'use client';

import { createContext, ReactNode } from 'react';

type ApplicationContextValue = {
  environment: string;
};

const ApplicationContext = createContext<ApplicationContextValue>({
  environment: 'development',
});

export const ApplicationProvider = ({
  environment,
  children,
}: ApplicationContextValue & { children: ReactNode }) => (
  <ApplicationContext.Provider value={{ environment }}>
    {children}
  </ApplicationContext.Provider>
);
